import "./_review.scss";
import { useContext } from "react";
//api
import { HOSTNAME, isExternalUrl } from "@src/utils";
// components
import Checkbox from "../../common/checkbox/Checkbox";
import { Tab, ButtonBox, Icon, Alert, ControlPanel } from "@shared/src";
// review
import { ReviewProviderData } from "./Provider";
import { useReviewActions } from "./useReviewActions";

// 리뷰 리스트 노출 제어 패널

// 리뷰 탭 (커뮤니티 리뷰/블로그 리뷰)
export const ReviewTab = () => {
  // context
  const {
    partner,
    filter,
    activeReviewTab,
    setActiveReviewTab,
    blogReviewTotal,
    setFilterModalIsOpen,
  } = useContext(ReviewProviderData).data;

  return (
    <>
      {/* 리뷰 타이틀 */}
      <div className="review-list-title">
        <h3>
          리뷰
          <span className="review-count">
            {activeReviewTab === 0 ? partner?.reviewSummary.totalReviewCnt : blogReviewTotal}
          </span>
        </h3>
      </div>
      {/* 리뷰 탭 */}
      <ControlPanel
        className="review-list-tab"
        left={
          <Tab
            type="r50"
            detailType="brown"
            tabs={[{ label: "웨딩북 리뷰" }, { label: "블로그 리뷰" }]}
            onSelect={(index) => {
              setActiveReviewTab(index);
            }}
          />
        }
        right={
          <div className="review-list-actions actions">
            {activeReviewTab === 0 && (
              <ButtonBox
                onClick={() => setFilterModalIsOpen(true)}
                size="tiny"
                type="outline"
                columnGapValue={6}
                theme={"gray200"}
                transparent={"all"}
                noPaddingPosition={"right"}
              >
                <Icon name="SwitchVertical" size={18} />
                {filter}
              </ButtonBox>
            )}
          </div>
        }
      />
    </>
  );
};

// 블라인드 리뷰 정보
export const ReviewBlindInfo = () => {
  // context
  const { partner, blindList } = useContext(ReviewProviderData).data;

  return (
    <>
      {blindList && blindList.length > 0 && (
        <div className="blind-review-summary-wrap">
          <Alert
            textAlign="left"
            content={`🙈 ${blindList.length}개의 리뷰가 블라인드 되었습니다.`}
            onClick={() => {
              window.location.href = isExternalUrl(
                `${HOSTNAME}/partner/${partner.uuid}/blind-reviews?hidetop=true`,
              );
            }}
          />
        </div>
      )}
    </>
  );
};

// 전체/현재 지점 리뷰 보기 체크박스
export const ReviewBranchCheck = () => {
  // context
  const { partner, setShowAllReview, showAllReview } = useContext(ReviewProviderData).data;
  const hasBranchStore = partner?.reviewSummary?.branchPartnerCnt
    ? partner.reviewSummary.branchPartnerCnt > 0
    : false; //지점 있음 여부

  // actions
  const { REVIEW_IS_FETCHING } = useReviewActions();

  return (
    <>
      {hasBranchStore && (
        <div className="review-branch-check">
          <Checkbox
            size={"small"}
            id={`branchCheck`}
            name="branchCheck"
            value={showAllReview.toString()}
            setValue={() => {
              if (!REVIEW_IS_FETCHING) setShowAllReview((value) => !value);
            }}
            checked={showAllReview}
            labelComponent={`현 지점 리뷰만 보기 ${partner.reviewSummary.reviewCnt}`}
          />
        </div>
      )}
    </>
  );
};
